


































































import { Component, Prop, Vue } from "vue-property-decorator";
import ModalHeader from "@/components/ModalHeader.vue";
import SingleChoiceAnswer from "./SingleChoiceAnswer.vue";
import MultipleChoiceAnswer from "./MultipleChoiceAnswer.vue";
import TextAnswer from "./TextAnswer.vue";
import EditorAnswer from "./EditorAnswer.vue";
import DateAnswer from "./DateAnswer.vue";
import TimeAnswer from "./TimeAnswer.vue";
import DateTimeAnswer from "./DateTimeAnswer.vue";
import SelectPopover from "@/components/SelectPopover.vue";
import { Form, FormQuestion } from "@/store/modules/types";
@Component({
  components: {
    ModalHeader,
    SingleChoiceAnswer,
    MultipleChoiceAnswer,
    TextAnswer,
    EditorAnswer,
    DateAnswer,
    TimeAnswer,
    DateTimeAnswer,
    SelectPopover,
  },
})
export default class FormViewer extends Vue {
  @Prop() readonly form!: Form;
  @Prop(Array) readonly questions!: Array<FormQuestion>;
  answer(questionId: number, value: string, jumpToKey, updateGap, updateAppt) {
    const question = this.questions.find((q) => q.id === questionId);
    if (question) {
      question.answer.value = value;
      question.answer.updateGap = updateGap;
      question.answer.updateAppt = updateAppt;
    }

  }
  get answers() {
    return this.questions
      .filter((q) => q.answer.value)
      .map((q) => {
        return {
          questionId: q.id,
          answer: q.answer.value,
          updateGap: q.answer.updateGap,
          updateAppt: q.answer.updateAppt,
        };
      });
  }
  gotoQuestion(id: string) {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView();
  }
  save() {
    if (this.answers.length) {
      this.$emit("save-answers", this.answers);
      this.close();
    }
  }
  close() {
    this.$modal.hide("form-viewer");
  }
}
